import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { newTherapyTemplateAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  DELETE_THERAPY_TEMPLATE_REQUEST,
  DELETE_THERAPY_TEMPLATE_FAILURE,
  DELETE_THERAPY_TEMPLATE_LOADING,
  DELETE_THERAPY_TEMPLATE_SUCCESS,
} = newTherapyTemplateAction;

function* deleteTherapyTemplate(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: DELETE_THERAPY_TEMPLATE_LOADING });

    const reponse = yield call(therapyPlanningService.deleteTherapyTemplates, payload.payload);
    if (reponse?.status === 200) {
      yield put({
        type: DELETE_THERAPY_TEMPLATE_SUCCESS,
        payload: reponse?.data,
      });
    } else throw reponse.data;
  } catch (error) {
    yield put({ type: DELETE_THERAPY_TEMPLATE_FAILURE, payload: error });
  }
}

function* deleteTherapyTemplateSaga() {
  yield takeEvery(DELETE_THERAPY_TEMPLATE_REQUEST, deleteTherapyTemplate);
}

export default deleteTherapyTemplateSaga;
